import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Backdrop, CircularProgress } from "@mui/material";
import ConditionalWrap from '../ConditionalWrap';
import styles from './ActivityIndicator.module.css';

const ActivityIndicator = ({ className, showBackdrop, ...other }) => {
  return (
    <ConditionalWrap
      condition={showBackdrop}
      wrap={(childrens) => (
        <Backdrop classes={{ root: styles.backdrop }} open>
          {childrens}
        </Backdrop>
      )}
    >
      <div className={cn('center', styles.root, className)}>
        <CircularProgress {...other} />
      </div>
    </ConditionalWrap>
  );
};

ActivityIndicator.propTypes = {
  size: Type.number,
  className: Type.string,
  showBackdrop: Type.bool,
};

ActivityIndicator.defaultProps = {
  size: 56,
  className: null,
  showBackdrop: false,
};

export default ActivityIndicator;
